// The Projects singleton tab's centre (#161): the author's projects
// (useProjectItems.ts), with pins shared with the left menu and this page's
// own sort and density (Detailed by default, pen decision 3), each kept per
// device. Opening a project opens the Studio on it; with none yet, the
// empty state sets up a new one.

import type { ReactNode } from "react";
import { ProjectsPage } from "../../../components/Projects/ProjectsPage.js";
import { RemoveProjectDialog } from "../../../components/Projects/RemoveProjectDialog.js";
import {
    DEFAULT_RECENT_LIST,
    type RecentListView,
} from "../../../components/Sidebar/recentList.js";
import { useProjectItems } from "../chrome/useProjectItems.js";
import { useRecentList } from "../chrome/useRecentList.js";
import { useAppShell } from "../context.js";

const PAGE_DEFAULTS: RecentListView = {
    ...DEFAULT_RECENT_LIST,
    density: "detailed",
};

export const ProjectsCentre = (): ReactNode => {
    const { library } = useAppShell();
    const projects = useProjectItems();
    const [page, onPageCommand] = useRecentList("projects-page", PAGE_DEFAULTS);
    return (
        <>
            <RemoveProjectDialog {...projects.removal} />
            <ProjectsPage
                items={projects.items}
                archived={projects.archived}
                cardsOf={projects.cardsOf}
                pins={projects.view}
                onPinsCommand={projects.onCommand}
                page={page}
                onPageCommand={onPageCommand}
                loading={library === null}
                onNewProject={projects.newProject}
            />
        </>
    );
};
